import { Component } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import {ThemeService, AuthService} from '../../providers/index';

@Component({
  selector: 'page-logout',
  templateUrl: 'logout.html'
})
export class LogoutPage {

  public project: string; //TODO
  constructor(private _theme: ThemeService, public navCtrl: NavController,
              public navParams: NavParams,private _auth: AuthService) {
    this.project = this._theme.getSlogan();
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad LogoutPage');
  }

  logout(): void{
    console.log('Signing Out: ' + this._auth.displayName());
    this._auth.signOut();
    //TODO: navigate to home
  }

  // Only go here if we need to
  ionViewCanEnter(): boolean {
    if(this._auth.authenticated){
      console.log('Authenticated so you can see this page: ');
      return true;
    } else {
      console.log('Not Authenticated so you cannot see this page: '); //TODO: Add reference to page
      return false;
    }
  }

}



// WEBPACK FOOTER //
// ./src/pages/logout/logout.ts